"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var numberDependencies = exports.numberDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createNumber: _factoriesAny.createNumber
};